// extracted by mini-css-extract-plugin
module.exports = {"address__title":"DeleteAddressForm_address__title__Mw9fR","tooltipWrapper":"DeleteAddressForm_tooltipWrapper__X9VfZ","tooltip":"DeleteAddressForm_tooltip___D9uv"};